import { ReactNode } from "react";

export const TablaTareasFuturas = ({ children }: { children: ReactNode }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered align-middle">
        <thead>
          <tr>
            <th style={{ width: "5%" }} scope="col">
              Nombre
            </th>
            <th scope="col" style={{ width: "10%" }}>
              Descripción
            </th>
               <th scope="col" style={{ width: "3%" }}>
              Prioridad
            </th>
            <th style={{ width: "5%" }} scope="col">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};
